/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const GetPharmacyCounselingBoothResponseTypename = "GetPharmacyCounselingBoothResponse" as const;

/**
 *
 * @export
 * @interface GetPharmacyCounselingBoothResponse
 */
export interface GetPharmacyCounselingBoothResponse {
  /**
   *
   * @type {number}
   * @memberof GetPharmacyCounselingBoothResponse
   */
  counselingBoothCount?: number;
  /**
   *
   * @type {string}
   * @memberof GetPharmacyCounselingBoothResponse
   */
  counselingBoothName?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetPharmacyCounselingBoothResponse
   */
  usableCounselingBoothVoiceAnnouncement?: boolean;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetPharmacyCounselingBoothResponse
   */
  readonly __typename?: string;
}

export function GetPharmacyCounselingBoothResponseFromJSON(json: any): GetPharmacyCounselingBoothResponse {
  return GetPharmacyCounselingBoothResponseFromJSONTyped(json, false);
}

export function GetPharmacyCounselingBoothResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetPharmacyCounselingBoothResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetPharmacyCounselingBoothResponseTypename,

    counselingBoothCount: !exists(json, "counseling_booth_count") ? undefined : json["counseling_booth_count"],
    counselingBoothName: !exists(json, "counseling_booth_name") ? undefined : json["counseling_booth_name"],
    usableCounselingBoothVoiceAnnouncement: !exists(json, "usable_counseling_booth_voice_announcement")
      ? undefined
      : json["usable_counseling_booth_voice_announcement"],
  };
}

export function GetPharmacyCounselingBoothResponseToJSON(object?: GetPharmacyCounselingBoothResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    counseling_booth_count: value.counselingBoothCount,
    counseling_booth_name: value.counselingBoothName,
    usable_counseling_booth_voice_announcement: value.usableCounselingBoothVoiceAnnouncement,
  };
}
